const reports = {
  getResults() {
    return this.request('/1/results');
  },

  getResultsById(id) {
    return this.request(`/results/${id}`);
  },

  getMainReports() {
    const defaults = {
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/reports/data', defaults);
  },

  getArchived(page, perPage) {
    const defaults = {
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    };

    return this.request(
      '/1/reports/archived?page='
        .concat(page)
        .concat('&per_page=')
        .concat(perPage),
      defaults
    );
  },

  putArchived(id, archived) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({ archive: archived }),
    };
    return this.request(`/1/reports/${id}/archive`, defaults);
  },

  postReport(data, fnUploadProgress, cancelToken) {
    const defaults = {
      method: 'POST',
      cancelToken,
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
      onUploadProgress: fnUploadProgress,
    };

    return this.request('/1/reports/', Object.assign(defaults, { data }));
  },

  sbomImport(data, fnUploadProgress, cancelToken) {
    const defaults = {
      method: 'POST',
      cancelToken,
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
      onUploadProgress: fnUploadProgress,
    };

    return this.request('/1/reports/sbom', Object.assign(defaults, { data }));
  },

  getDashboardSummary() {
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/dashboards/overview', Object.assign(defaults));
  },
  getScannedReports(obj) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/reports/list', Object.assign(defaults, { data }));
  },

  getScannedUpdateCheck(obj) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.requestHtml('/1/reports/list', Object.assign(defaults, { data }));
  },

  getScannedFileList(obj, ufid) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${ufid}/scanned_list`, Object.assign(defaults, { data }));
  },
  getScannedDetail(uploadedFileid, scannedFileId, componentIds, type) {
    const uploaded_file_id = uploadedFileid;
    const scanned_file_id = scannedFileId;
    const component_ids = componentIds;
    let data;

    if (type) {
      data = {
        precision_level: type,
        component_ids,
      };
    } else {
      data = {
        component_ids,
      };
    }

    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${uploaded_file_id}/files/${scanned_file_id}/overview`, Object.assign(defaults, { data }));
  },
  getComponentVersionWithDetail(uploadedFileid, scannedFileId, componentId) {
    const uploaded_file_id = uploadedFileid;
    const scanned_file_id = scannedFileId;
    const component_id = componentId;
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${uploaded_file_id}/files/${scanned_file_id}/components/${component_id}/versions`, defaults);
  },
  getScannedFileEditDetails(uploadedFileid, scannedFileId, type) {
    const uploaded_file_id = uploadedFileid;
    const scanned_file_id = scannedFileId;
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    if (type) {
      return this.request(`/1/reports/${uploaded_file_id}/files/${scanned_file_id}/edit?precision_level=${type}`, defaults);
    }
    return this.request(`/1/reports/${uploaded_file_id}/files/${scanned_file_id}/edit`, defaults);
  },
  getPrecisionLevel(uploadedFileid) {
    const uploaded_file_id = uploadedFileid;
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${uploaded_file_id}/precision_level`, defaults);
  },
  getLitigatorList(obj) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/component_litigators/list', Object.assign(defaults, { data }));
  },
  getLitigatorDetail(obj) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/component_litigators/overview', Object.assign(defaults, { data }));
  },
  getLicenseList(obj) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/component_licenses/list', Object.assign(defaults, { data }));
  },
  getLicenseDetail(obj) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/component_licenses/overview', Object.assign(defaults, { data }));
  },
  getLicensefileList(obj, ufid) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${ufid}/license_list`, Object.assign(defaults, { data }));
  },
  getLicenseFileDetail(obj, ufid) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${ufid}/license_overview`, Object.assign(defaults, { data }));
  },
  getLitigatorfileList(obj, ufid) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${ufid}/litigator_list`, Object.assign(defaults, { data }));
  },
  getLitigatorFileDetail(obj, ufid) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${ufid}/litigator_overview`, Object.assign(defaults, { data }));
  },
  getSecurityList(obj) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/component_securities/list', Object.assign(defaults, { data }));
  },
  getSecurityDetail(obj) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/component_securities/overview', Object.assign(defaults, { data }));
  },

  getSecurityfileList(obj, ufid) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${ufid}/security_list`, Object.assign(defaults, { data }));
  },
  getSecurityFileDetail(obj, ufid) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${ufid}/security_overview`, Object.assign(defaults, { data }));
  },
  getCNVDList(obj, ufid) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${ufid}/cnvd_list`, Object.assign(defaults, { data }));
  },
  getCNVDDetail(obj, ufid) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${ufid}/cnvd_overview`, Object.assign(defaults, { data }));
  },
  getComponentList(obj) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/file_components/list', Object.assign(defaults, { data }));
  },
  getComponentDetail(obj) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/file_components/overview', Object.assign(defaults, { data }));
  },
  getComponentfileList(obj, ufid) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${ufid}/component_list`, Object.assign(defaults, { data }));
  },
  getComponentFileDetail(obj, ufid) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${ufid}/component_overview`, Object.assign(defaults, { data }));
  },
  getPolicyList(obj) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/policies/list', Object.assign(defaults, { data }));
  },
  getPolicyDetail(obj) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/policies/overview', Object.assign(defaults, { data }));
  },
  getPolicyRevisionSummary(psid) {
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/policies/${psid}/revision_summary`, defaults);
  },
  getRevisionListWithPolicy(obj, policyId) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/policies/${policyId}/revision`, Object.assign(defaults, { data }));
  },
  getPolicyfileList(obj, ufid) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${ufid}/policy_list`, Object.assign(defaults, { data }));
  },
  getPolicyFileDetail(obj, ufid) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${ufid}/policy_overview`, Object.assign(defaults, { data }));
  },
  getTreeScannedReport(token, reportId, fileId) {
    const defaults = {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    };

    return this.request(`/1/reports/${reportId}/tree/${fileId}`, defaults);
  },

  getResultsByReport(reportId) {
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request(`/1/reports/${reportId}`, defaults);
  },

  getResultsBySecurity(reportId) {
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request(`/1/reports/${reportId}/rescan`, defaults);
  },

  rescanReport(id) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${id}/rescan`, defaults);
  },

  refreshSecurityReport(id) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${id}/refresh_security`, defaults);
  },

  getFileDetail(reportId, fileId) {
    const defaults = {
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${reportId}/files/${fileId}/details`, defaults);
  },

  getDeepOverview(reportId, fileId) {
    const defaults = {
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${reportId}/files/${fileId}/overview`, defaults);
  },

  getDeepHtmlList(reportId, fileId) {
    const defaults = {
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.requestHtml(
      `/1/reports/${reportId}/files/${fileId}/detailed_report_list`,
      defaults
    );
  },

  getDeepHtml(reportId, fileId, type) {
    const defaults = {
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.requestHtml(
      `/1/reports/${reportId}/files/${fileId}/detailed_report?report_type=${type}`,
      defaults
    );
  },

  getDeepIdentifiers(reportId, fileId, page = 1) {
    const defaults = {
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(
      `/1/reports/${reportId}/files/${fileId}/identifiers?page=${page}`,
      defaults
    );
  },

  getFileCompliance(reportId, fileId) {
    const defaults = {
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${reportId}/files/${fileId}/compliance`, defaults);
  },
  getResume(id) {
    const defaults = {
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${id}/file_records`, defaults);
  },
  getOverviewSummary() {
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/customer_company/overview_summary', defaults);
  },
  getComponentSummary() {
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/customer_company/component_summary', defaults);
  },
  getSecuritySummary() {
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/customer_company/security_summary', defaults);
  },
  getLicenseSummary() {
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/customer_company/license_litigator_summary', defaults);
  },
  getPolicySummary() {
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/customer_company/policy_summary', defaults);
  },

  getPolicySummaryDetail(uid, type) {
    const uploaded_file_id = uid;
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    if (type) {
      return this.request(`/1/reports/${uploaded_file_id}/policy_summary?precision_level=${type}`, defaults);
    }
    return this.request(`/1/reports/${uploaded_file_id}/policy_summary`, defaults);
  },
  getComponentSummaryDetail(uid, type) {
    const uploaded_file_id = uid;
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    if (type) {
      return this.request(`/1/reports/${uploaded_file_id}/component_summary?precision_level=${type}`, defaults);
    }
    return this.request(`/1/reports/${uploaded_file_id}/component_summary`, defaults);
  },
  getOverviewSummaryDetail(uid, type) {
    const uploaded_file_id = uid;
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    if (type) {
      return this.request(`/1/reports/${uploaded_file_id}/overview_summary?precision_level=${type}`, defaults);
    }
    return this.request(`/1/reports/${uploaded_file_id}/overview_summary`, defaults);
  },
  getSecuritySummaryDetail(uid, type) {
    const uploaded_file_id = uid;
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    if (type) {
      return this.request(`/1/reports/${uploaded_file_id}/security_summary?precision_level=${type}`, defaults);
    }
    return this.request(`/1/reports/${uploaded_file_id}/security_summary`, defaults);
  },
  getLicenseSummaryDetail(uid, type) {
    const uploaded_file_id = uid;
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    if (type) {
      return this.request(`/1/reports/${uploaded_file_id}/license_litigator_summary?precision_level=${type}`, defaults);
    }
    return this.request(`/1/reports/${uploaded_file_id}/license_litigator_summary`, defaults);
  },
  deleteReport(id) {
    const defaults = {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${id}`, defaults);
  },
  newScanDelete(data) {
    const defaults = {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/reports/new_scan', Object.assign(defaults, { data }));
  },
  destroySelected(data) {
    const defaults = {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/reports/destroy_selected', Object.assign(defaults, { data }));
  },
  cancelReport(id) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${id}/cancel`, defaults);
  },
  downloadReport(id) {
    const defaults = {
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${id}/resume`, defaults);
  },
  getExportedReport(location) {
    const defaults = {
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
      responseType: 'arraybuffer',
    };
    return this.request(location, defaults, '', true);
  },
  getMatchedList(reportId, fileId, type) {
    const defaults = {
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    if (type) {
      return this.requestHtml(`/1/reports/${reportId}/files/${fileId}/detailed_report_list?precision_level=${type}`, defaults);
    }
    return this.requestHtml(`/1/reports/${reportId}/files/${fileId}/detailed_report_list`, defaults);
  },

  getMatchedDetail(obj, reportId, fileId, type) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.requestHtml(
      `/1/reports/${reportId}/files/${fileId}/${type}`,
      Object.assign(defaults, { data })
    );
  },

  /*
  getMatchedList(reportId, page, perPage) {
    const defaults = {
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${reportId}/file_records?page=`.concat(page).concat('&per_page=').concat(perPage), defaults);
  },
*/
  getCVEDetail(CVENum) {
    const defaults = {
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/clarities/cve_info/${CVENum}`, defaults);
  },

  getVulnDetail(vulnNum) {
    const defaults = {
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/clarities/vuln_info/${vulnNum}`, defaults);
  },
  getSearchResult(obj) {
    const data = obj || {};
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request(
      '/1/reports?search='.concat(
        data.searchKeyword,
        '&start=',
        data.startDate || '',
        '&end=',
        data.endDatae || '',
        '&filter=',
        data.checked || '',
        '&order=',
        data.order || '',
        '&page=',
        data.page || '1',
        '&limit=',
        data.limit || 10
      ),
      Object.assign(defaults, { data })
    );
  },
  getComponentSecurityDetail(obj) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/component_securities/detail', Object.assign(defaults, { data }));
  },
  getComponentLitigatorDetail(obj) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/component_litigators/detail', Object.assign(defaults, { data }));
  },
  toggleBookmark(obj) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/bookmarks/toggle', Object.assign(defaults, { data }));
  },
  getProjectVersionTree(obj) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/reports/new_scan_project_list', Object.assign(defaults, { data }));
  },
  getScanList(obj) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/reports/new_scan', Object.assign(defaults, { data }));
  },

  getNewScanUpdateCheck(obj) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.requestHtml('/1/reports/new_scan', Object.assign(defaults, { data }));
  },

  getScanningText() {
    const defaults = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/reports/scanning_text', defaults);
  },

  getScanningStatus(obj) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.requestHtml('/1/reports/scanning_status', Object.assign(defaults, { data }));
  },

  setFileMove(data, uploadedFileid) {
    const uploaded_file_id = uploadedFileid;
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request(`/1/reports/${uploaded_file_id}`, Object.assign(defaults, { data }));
  },

  getReportedProjectList(obj) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/reports/project_filter', Object.assign(defaults, { data }));
  },

  getReportedProjectVersionList(obj, pid) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${pid}/project_version_filter`, Object.assign(defaults, { data }));
  },

  setCompareData(obj) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/reports/compare', Object.assign(defaults, { data }));
  },
  getCompareComponent(obj) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/reports/compare_components', Object.assign(defaults, { data }));
  },
  getCompareSecurity(obj) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/reports/compare_securities', Object.assign(defaults, { data }));
  },
  getCompareLicense(obj) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/reports/compare_licenses', Object.assign(defaults, { data }));
  },
  getCompareLitigator(obj) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/reports/compare_litigators', Object.assign(defaults, { data }));
  },
  getComparePolicy(obj) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/reports/compare_policies', Object.assign(defaults, { data }));
  },
  saveScannedFileChanges(data, uploadedFileid, scannedFileId) {
    const uploaded_file_id = uploadedFileid;
    const scanned_file_id = scannedFileId;
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request(`/1/reports/${uploaded_file_id}/files/${scanned_file_id}/save`, Object.assign(defaults, { data }));
  },
  searchCVECode(array) {
    const data = array;
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/component_securities/search-component-securities', Object.assign(defaults, { data }));
  },
  getPackageDependency(uploadedFileId, scannedFileId) {
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${uploadedFileId}/files/${scannedFileId}/dependency`, Object.assign(defaults));
  },
  getfileComponentVersionRisk(obj) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/file_components/component_version_risk', Object.assign(defaults, { data }));
  },
  getComponentVersionRisk(obj, ufid) {
    const data = obj || {};
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${ufid}/component_version_risk`, Object.assign(defaults, { data }));
  },
  getComponentPatchVersions(obj) {
    const data = obj;
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/file_components/patch_version', Object.assign(defaults, { data }));
  },
  getComponentPatchVersionRisk(obj) {
    const data = obj;
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/file_components/version_risk', Object.assign(defaults, { data }));
  },

  getLeakageList(ufid, obj) {
    const data = obj;
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${ufid}/leakage_list`, Object.assign(defaults, { data }));
  },
  getComponentFiles(ufid, arr) {
    const data = arr || [];
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${ufid}/component_files`, Object.assign(defaults, { data }));
  },
  getPacakageInfoWithSpdx(ufid) {
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${ufid}/spdx`, Object.assign(defaults));
  },
  createSPDXFileDownload(ufid, obj) {
    const data = obj;
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
      responseType: 'blob',
    };
    return this.request(`/1/reports/${ufid}/spdx/files`, Object.assign(defaults, { data }), '', true);
  },
  getPacakageInfoWithCycloneDx(ufid) {
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${ufid}/cyclone_dx`, Object.assign(defaults));
  },
  createCycloneDXFileDownload(ufid, obj) {
    const data = obj;
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
      responseType: 'blob',
    };
    return this.request(`/1/reports/${ufid}/cyclone_dx/components`, Object.assign(defaults, { data }), '', true);
  },
  getPacakageInfoWithVex(ufid) {
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${ufid}/vex`, Object.assign(defaults));
  },
  createVexFileDownload(ufid, obj) {
    const data = obj;
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
      responseType: 'blob',
    };
    return this.request(`/1/reports/${ufid}/vex/components`, Object.assign(defaults, { data }), '', true);
  },
  getCBOMInfo(ufid) {
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${ufid}/cbom`, Object.assign(defaults));
  },
  createCBOMDownload(ufid, obj) {
    const data = obj;
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
      responseType: 'blob',
    };
    return this.request(`/1/reports/${ufid}/cbom/components`, Object.assign(defaults, { data }), '', true);
  },
  postReportWithUrl(data) {
    const defaults = {
      method: 'POST',
      //cancelToken,
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
      //onUploadProgress: fnUploadProgress,
    };

    return this.request('/1/reports/upload', Object.assign(defaults, { data }));
  },
  getCveList(data) {
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/policies/search-security', Object.assign(defaults, { data }));
  },
  getCveDetailList(obj) {
    const data = obj;
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/component_securities/details', Object.assign(defaults, { data }));
  },
  getNISInfo(uploadedFileid) {
    const uploaded_file_id = uploadedFileid;
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${uploaded_file_id}/nis`, defaults);
  },
  setNISInfo(obj, uploadedFileid) {
    const data = obj;
    const uploaded_file_id = uploadedFileid;
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
      responseType: 'blob',
    };
    return this.request(`/1/reports/${uploaded_file_id}/nis`, Object.assign(defaults, { data }), '', true);
  },
  searchCveCodeWithRisk(obj) {
    const data = obj;
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/component_securities/search-security', Object.assign(defaults, { data }));
  },
  searchComponentLicenses(obj) {
    const data = obj;
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/component_licenses/search-component-licenses', Object.assign(defaults, { data }));
  },
  searchComponentSecurities(obj) {
    const data = obj;
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/component_securities/search-component-securities', Object.assign(defaults, { data }));
  },
  getComponentEdit(uid, obj) {
    const data = obj;
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${uid}/component_edit`, Object.assign(defaults, { data }));
  },
  updateOrSaveComponent(data, uploadedFileid) {
    const uploaded_file_id = uploadedFileid;
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request(`/1/reports/${uploaded_file_id}/component_save`, Object.assign(defaults, { data }));
  },
  getDefinedProjectForCustomerCompany(udi) {
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/customer_company/defined_project?user_defined_id=${udi}`, defaults);
  },
  setReportFileComment(obj) {
    const { data } = obj;
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${obj.uid}/files/${obj.sfid}/comment`, Object.assign(defaults, { data }));
  },
  setReportComponentComment(obj) {
    const { data } = obj;
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${obj.uid}/component_comment`, Object.assign(defaults, { data }));
  },
  getEmptyReportForEdit(uid) {
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${uid}/empty_edit`, defaults);
  },
  searchFilesForReport(uid, obj) {
    const data = obj;
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${uid}/search-file`, Object.assign(defaults, { data }));
  },
  saveEmptyReport(uid, obj) {
    const data = obj;
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request(`/1/reports/${uid}/empty_save`, Object.assign(defaults, { data }));
  },
  getExportMatchedReport(uid, sfid, obj) {
    const data = obj;
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
      responseType: 'blob',
    };
    return this.request(`/1/reports/${uid}/files/${sfid}/export_matches`, Object.assign(defaults, { data }), '', true);
  },
};

export default reports;
